<template>
  <div style="width: 100%;font-family: 楷体">
    <div class="div1-PCI">
      荣誉资质
    </div>
    <!--    第三层-->
    <div class="div3-PCI">
      <div class="div3-div-PCI" v-for="(item,index) in honorImgList" :key="index">
        <div style="font-size: 20px;text-align: left">
          <br><br>
          名称：{{item.title}}
          <br>
          发布时间：{{item.dateTime}}
        </div>
        <div style="width: 100%">
          <img :src="item.honorImg" alt="" width="100%">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "PcHonorQualifications",
    data() {
      return {
        honorImgList: [
          {
            title: '实用新型专利证书',
            dateTime:'2017年08月29日',
            honorImg: require('../../../public/image/专利封面.jpg')
          },
          {
            title: '禽类尸体环保回收利用处理装置',
            dateTime:'2017年10月03日',
            honorImg: require('../../../public/image/专利1.jpg')
          },
          {
            title: '一种禽类尸体处理装置用废气净化装置',
            dateTime:'2017年08月29日',
            honorImg: require('../../../public/image/专利2.jpg')
          },
        ]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/computer/second/PcHonorQualifications.vue